import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import API from '@/lib/API';
import { Tag } from '@/types';

@Module
export default class Tags extends VuexModule {
  data: Tag[] = []

  get tags(): Tag[] {
    return this.data;
  }

  @Mutation
  setTags({ tags }: { tags: Tag[] }) {
    console.log('mutations:setTags'); // eslint-disable-line no-console

    const data: Tag[] = [];

    tags.forEach((doc) => {
      data.push({
        id: doc.id,
        name: doc.name,
        color: doc.color,
        isActive: doc.isActive,
        hidden: doc.hidden,
        showInOperationList: doc.showInOperationList,
        showInConnectionList: doc.showInConnectionList,
      });
    });

    this.data = data;

    return Promise.resolve();
  }

  @Action({ rawError: true })
  async initTags() {
    console.log('actions:initTags'); // eslint-disable-line no-console

    return this.context.dispatch('updateTags');
  }

  @Action({ rawError: true })
  async updateTags() {
    console.log('actions:updateTags'); // eslint-disable-line no-console

    const tags = await API.getTags();

    if (tags instanceof Error) return Promise.reject(tags);

    return this.context.commit('setTags', { tags });
  }
}
